const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse} from 'bootstrap';
import SimpleLightbox from "simplelightbox";

require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_slider.js');
require('./utilities/pdw_hide_link.js');
//require('./utilities/pdw_woocommerce.js');

//Lightbox
let lightbox = new SimpleLightbox('.pdw-lightbox a', { /* options */});

//Drilldown menu
window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('ul.mobile-drilldown-menu li.menu-item-has-children > a').forEach(element => {
        //Create previous button
        let previous = document.createElement('span');
        element.nextElementSibling.prepend(previous);
        previous.classList.add("pdw-submenu-close");
        previous.innerHTML = element.innerHTML;
        previous.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.remove("open");
        });
        //Create open button
        let span = document.createElement('span');
        element.appendChild(span);
        span.classList.add("pdw-submenu-open");
        span.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.add("open");
            document.getElementById('pdw-mobile-menu').scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        });
    });
    document.querySelector('.pdw-mobile-menu-open').addEventListener('click', () => {
        document.querySelector('.bg-blur').classList.add('h-100');
    });
    document.querySelector('.pdw-mobile-menu-close').addEventListener('click', () => {
        document.querySelector('.bg-blur').classList.remove('h-100');
    });
});

//sliders
import Splide from '@splidejs/splide';

//slider home services
if (document.querySelector('.home_services_slider')) {
    document.addEventListener('DOMContentLoaded', function () {

        var home_services_slider = new Splide('.home_services_slider', {
            type: 'loop',
            speed: '800',
            perPage: 3,
            breakpoints: {
                1024: {
                    perPage: 2,
                },
                640: {
                    perPage: 1,
                },
            },
            perMove: 2,
            gap: '2rem',
            arrows: false,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            classes: {
                pagination: 'slider--dots',
                page: 'dot'
            }
            /*breakpoints: {
                767: {
                    perPage: 1
                },
                991: {
                    perPage: 2
                }
            }*/
        });

        home_services_slider.mount();
    });
}

//slider home advices
if (document.querySelector('.home_advices_slider')) {
    document.addEventListener('DOMContentLoaded', function () {

        var home_advices_slider = new Splide('.home_advices_slider', {
            type: 'loop',
            autoplay: true,
            interval: '4000',
            speed: '800',
            perPage: 1,
            perMove: 1,
            arrows: false,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            pagination: false,
        });

        home_advices_slider.mount();

        var btn_prev = document.querySelector('.home_advices_slider .nav--prev');
        var btn_next = document.querySelector('.home_advices_slider .nav--next');

        btn_prev.addEventListener("click", function () {
            home_advices_slider.go('<');
        });
        btn_next.addEventListener("click", function () {
            home_advices_slider.go('>');
        });
    });
}